/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q_Stok_SenkronizasyonInputs */

const tr_faq_q_stok_senkronizasyon = /** @type {(inputs: Faq_Q_Stok_SenkronizasyonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stok senkronizasyonu ne kadar sürede gerçekleşir?`)
};

const en_faq_q_stok_senkronizasyon = /** @type {(inputs: Faq_Q_Stok_SenkronizasyonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How often does stock sync?`)
};

const de_faq_q_stok_senkronizasyon = /** @type {(inputs: Faq_Q_Stok_SenkronizasyonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie oft wird der Bestand synchronisiert?`)
};

const ru_faq_q_stok_senkronizasyon = /** @type {(inputs: Faq_Q_Stok_SenkronizasyonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как часто синхронизируется остаток?`)
};

/**
* | output |
* | --- |
* | "How often does stock sync?" |
*
* @param {Faq_Q_Stok_SenkronizasyonInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_q_stok_senkronizasyon = /** @type {((inputs?: Faq_Q_Stok_SenkronizasyonInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q_Stok_SenkronizasyonInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q_stok_senkronizasyon(inputs)
	if (locale === "de") return de_faq_q_stok_senkronizasyon(inputs)
	if (locale === "ru") return ru_faq_q_stok_senkronizasyon(inputs)
	return tr_faq_q_stok_senkronizasyon(inputs)
});